import {useCallback, useEffect, useRef, useState} from 'react';

const SWATCH_SIZE = 2; // rem
const MARGIN = 0.25; // rem

export default function useColorSwatchesMobileOverflow(totalColorCount) {
  const [hasOverflow, setHasOverflow] = useState(false);
  const scrollContainerRef = useRef(null);

  const calculateOverflow = useCallback(() => {
    const screenWidth = window.innerWidth;

    // Convert rem to pixels (assuming 1rem = 16px)
    const remToPixels = 16;
    const swatchSize = SWATCH_SIZE * remToPixels;
    const margin = MARGIN * remToPixels;

    // Each swatch takes: width + 2*margin
    const swatchTotalWidth = swatchSize + 2 * margin;

    // Available width is screen width (container margins/padding cancel out)
    const availableWidth = screenWidth;

    // Calculate how many swatches can fit
    const swatchesThatFit = Math.floor(availableWidth / swatchTotalWidth);

    // Has overflow if total colors exceed what fits
    setHasOverflow(totalColorCount > swatchesThatFit);
  }, [totalColorCount]);

  // Check overflow on mount, breakpoint change, and totalColorCount change
  useEffect(() => {
    calculateOverflow();

    const handleResize = () => calculateOverflow();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [calculateOverflow]);

  return {hasOverflow, scrollContainerRef};
}
